/*
 * @Author: your name
 * @Date: 2021-01-21 21:07:02
 * @LastEditTime: 2021-01-21 21:09:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/modules/manageCenterContent.js
 */

const ANIMATED_TIME_MS = 400

export {
  ANIMATED_TIME_MS
}